<div [style]="isoStyle" [style.top]="reportIso.top" [style.left]="reportIso.left" [style.width]="reportIso.width"
  [style.height]="reportIso.height" (click)="onClick($event)" draggable="true" (dragstart)="onDragStart($event)"
  (dragover)="onDragOver($event)" (drop)="onDrop($event)">
  <p [style]="imgStyle"><b>Interactive ISO image</b></p>
</div>
